/**
 * Bright Ideas collection page: filters + sort + "show more", all in the browser.
 * Loads every product in the collection from ?view=bi-data (250 per request),
 * works out which filters make sense for this category (see GROUPS in bi-cards.js)
 * and only shows filters with at least two choices.
 */
(function () {
  function start() {
    document.querySelectorAll('[data-bi-collection]:not([data-bi-init])').forEach(function (root) {
      root.setAttribute('data-bi-init', '1');
      init(root);
    });
  }

  function init(root) {
    var BI = window.BICards;
    var url = root.getAttribute('data-url');
    var total = parseInt(root.getAttribute('data-count'), 10) || 0;
    var batch = parseInt(root.getAttribute('data-batch'), 10) || 24;
    var grid = root.querySelector('[data-bi-grid]');
    var filtersEl = root.querySelector('[data-bi-filters]');
    var countEl = root.querySelector('[data-bi-count]');
    var sortSel = root.querySelector('[data-bi-sort]');
    var moreWrap = root.querySelector('[data-bi-more-wrap]');
    var moreBtn = root.querySelector('[data-bi-more]');
    var progress = root.querySelector('[data-bi-progress]');
    var activeEl = root.querySelector('[data-bi-active]');
    var panel = root.querySelector('[data-bi-filters-panel]');
    var openBtn = root.querySelector('[data-bi-filter-open]');
    var openCount = root.querySelector('[data-bi-filter-count]');
    var scrim = root.querySelector('.bi-coll__scrim');
    var showBtn = root.querySelector('[data-bi-show-results]');

    var products = [];
    var groups = [];
    var sel = {};
    var shown = batch;
    var filtered = [];

    if (!total) { filtersEl.innerHTML = ''; return; }

    var pages = Math.min(Math.ceil(total / 250), 8);
    var reqs = [];
    for (var i = 1; i <= pages; i++) {
      reqs.push(fetch(url + (url.indexOf('?') > -1 ? '&' : '?') + 'view=bi-data&page=' + i, { credentials: 'same-origin' }).then(function (r) {
        if (!r.ok) throw new Error(r.status);
        return r.json();
      }));
    }
    Promise.all(reqs).then(function (res) {
      res.forEach(function (d) { products = products.concat(d.products || []); });
      products.forEach(function (p, idx) { p._i = idx; BI.register(p); });
      BI.setPriceBuckets(products);
      setup();
    }).catch(function () {
      // Keep the server-rendered cards + normal pagination if data can't load
      filtersEl.innerHTML = '<p class="bi-coll__loading">Filters are unavailable right now.</p>';
    });

    function familyOfCollection() {
      var counts = {};
      products.forEach(function (p) { var f = BI.family(p); counts[f] = (counts[f] || 0) + 1; });
      var best = 'small', n = 0;
      Object.keys(counts).forEach(function (k) { if (counts[k] > n) { n = counts[k]; best = k; } });
      return n >= products.length * 0.4 ? best : 'small';
    }

    function setup() {
      var fam = familyOfCollection();
      var keys = (BI.GROUPS[fam] || []).concat(BI.COMMON);
      groups = [];
      keys.forEach(function (k) {
        var ex = BI.EX[k];
        if (!ex) return;
        var counts = {};
        var withValue = 0;
        products.forEach(function (p) {
          var vals = BI.values(p, k);
          if (vals.length) withValue++;
          vals.forEach(function (v) { counts[v] = (counts[v] || 0) + 1; });
        });
        var vals = Object.keys(counts);
        if (k === 'stock') {
          // Only useful when some products are out of stock
          if (!vals.length || counts['In stock'] === products.length) return;
        } else if (ex.multi) {
          vals = vals.filter(function (v) { return counts[v] < products.length; });
          if (!vals.length) return;
        } else if (vals.length < 2 || withValue < Math.max(2, products.length * 0.2)) {
          return;
        }
        groups.push({ key: k, label: ex.label, values: orderValues(k, vals, counts), multi: !!ex.multi });
      });
      readURL();
      renderFilters();
      root.classList.add('bi-coll--ready');
      apply(false);
    }

    function orderValues(k, vals, counts) {
      var ex = BI.EX[k];
      var order = k === 'price' ? BI.priceOrder() : ex.order;
      if (order) {
        return vals.slice().sort(function (a, b) {
          var ia = order.indexOf(a), ib = order.indexOf(b);
          return (ia < 0 ? 99 : ia) - (ib < 0 ? 99 : ib) || a.localeCompare(b);
        });
      }
      if (k === 'energy') return vals.slice().sort();
      if (ex.numeric || vals.every(function (v) { return /^\d/.test(v); })) {
        return vals.slice().sort(function (a, b) { return parseFloat(a) - parseFloat(b); });
      }
      if (k === 'brand') return vals.slice().sort(function (a, b) { return a.localeCompare(b); });
      return vals.slice().sort(function (a, b) { return counts[b] - counts[a] || a.localeCompare(b); });
    }

    /* ---------- Filter UI ---------- */
    function slug(s) { return String(s).toLowerCase().replace(/[^a-z0-9]+/g, '-'); }
    function renderFilters() {
      if (!groups.length) { filtersEl.innerHTML = ''; root.classList.add('bi-coll--nofilters'); return; }
      var LIMIT = 6;
      filtersEl.innerHTML = groups.map(function (g, gi) {
        var id = 'bi-f-' + g.key;
        var opts = g.values.map(function (v, vi) {
          var oid = id + '-' + slug(v);
          return '<li' + (vi >= LIMIT ? ' class="bi-fopt--extra" hidden' : '') + '>' +
            '<label class="bi-fopt" for="' + oid + '"><input type="checkbox" id="' + oid + '" data-g="' + g.key + '" value="' + BI.esc(v) + '"' +
            (sel[g.key] && sel[g.key].indexOf(v) > -1 ? ' checked' : '') + '>' +
            '<span class="bi-fopt__label">' + BI.esc(v) + '</span><span class="bi-fopt__count" data-count-for="' + oid + '"></span></label></li>';
        }).join('');
        var more = g.values.length > LIMIT
          ? '<button type="button" class="bi-fgroup__more" data-more="' + g.key + '" aria-expanded="false">Show all ' + g.values.length + '</button>'
          : '';
        var open = gi < 6 || (sel[g.key] && sel[g.key].length);
        return '<details class="bi-fgroup"' + (open ? ' open' : '') + '><summary class="bi-fgroup__title">' + BI.esc(g.label) +
          '<span class="bi-fgroup__sel" data-sel-for="' + g.key + '"></span></summary>' +
          '<fieldset class="bi-fgroup__body"><legend class="visually-hidden">' + BI.esc(g.label) + '</legend><ul role="list">' + opts + '</ul>' + more + '</fieldset></details>';
      }).join('');
    }

    filtersEl.addEventListener('change', function (e) {
      var cb = e.target;
      if (!cb.matches('input[data-g]')) return;
      var k = cb.getAttribute('data-g');
      var list = sel[k] || (sel[k] = []);
      if (cb.checked) { if (list.indexOf(cb.value) === -1) list.push(cb.value); }
      else sel[k] = list.filter(function (v) { return v !== cb.value; });
      if (!sel[k].length) delete sel[k];
      shown = batch;
      apply(true);
    });
    filtersEl.addEventListener('click', function (e) {
      var b = e.target.closest('[data-more]');
      if (!b) return;
      var expanded = b.getAttribute('aria-expanded') === 'true';
      b.closest('fieldset').querySelectorAll('.bi-fopt--extra').forEach(function (li) { li.hidden = expanded; });
      b.setAttribute('aria-expanded', expanded ? 'false' : 'true');
      b.textContent = expanded ? 'Show all ' + b.closest('fieldset').querySelectorAll('li').length : 'Show fewer';
    });

    /* ---------- Filtering ---------- */
    function passes(p, skipKey) {
      for (var i = 0; i < groups.length; i++) {
        var k = groups[i].key;
        if (k === skipKey || !sel[k]) continue;
        var vals = BI.values(p, k);
        if (groups[i].multi) {
          // Features: must have every ticked feature
          if (!sel[k].every(function (v) { return vals.indexOf(v) > -1; })) return false;
        } else if (!vals.some(function (v) { return sel[k].indexOf(v) > -1; })) {
          return false;
        }
      }
      return true;
    }

    function sortList(list) {
      var s = sortSel ? sortSel.value : 'featured';
      var out = list.slice();
      var priced = function (p) { return p.p > 0 ? p.p : Infinity; };
      if (s === 'price-asc') out.sort(function (a, b) { return priced(a) - priced(b) || a._i - b._i; });
      else if (s === 'price-desc') out.sort(function (a, b) { return (b.p || 0) - (a.p || 0) || a._i - b._i; });
      else if (s === 'title') out.sort(function (a, b) { return a.t.localeCompare(b.t); });
      else if (s === 'newest') out.sort(function (a, b) { return (b.d || 0) - (a.d || 0); });
      else out.sort(function (a, b) { return a._i - b._i; });
      // Out-of-stock products go to the end in every sort
      out.sort(function (a, b) { return (b.a ? 1 : 0) - (a.a ? 1 : 0); });
      return out;
    }

    function apply(userChange) {
      filtered = sortList(products.filter(function (p) { return passes(p, null); }));
      renderGrid(false);
      updateCounts();
      renderActive();
      writeURL();
      var n = filtered.length;
      countEl.textContent = n === products.length ? n + ' products' : n + ' of ' + products.length + ' products';
      if (showBtn) showBtn.textContent = 'Show ' + n + ' product' + (n === 1 ? '' : 's');
      var active = Object.keys(sel).reduce(function (a, k) { return a + sel[k].length; }, 0);
      if (openCount) openCount.textContent = active ? ' (' + active + ')' : '';
      if (userChange && window.matchMedia('(min-width: 990px)').matches) {
        var top = root.getBoundingClientRect().top + window.scrollY - 120;
        if (window.scrollY > top) window.scrollTo({ top: top, behavior: 'smooth' });
      }
    }

    function renderGrid(append) {
      var from = append ? grid.children.length : 0;
      var slice = filtered.slice(from, shown);
      var html = slice.map(function (p, i) {
        return '<li class="bi-grid__item">' + BI.cardHTML(p, from + i > 3 ? true : false) + '</li>';
      }).join('');
      if (!filtered.length) {
        grid.innerHTML = '<li class="bi-coll__empty"><p>No products match all of these filters.</p>' +
          '<button type="button" class="bi-btn bi-btn--secondary" data-bi-clear-all>Clear all filters</button></li>';
      } else if (append) {
        grid.insertAdjacentHTML('beforeend', html);
        var firstNew = grid.children[from];
        var link = firstNew && firstNew.querySelector('.bi-card__title a');
        if (link) link.focus({ preventScroll: true });
      } else {
        grid.innerHTML = html;
      }
      var left = filtered.length - Math.min(shown, filtered.length);
      moreWrap.hidden = left <= 0;
      if (progress) progress.textContent = 'Showing ' + Math.min(shown, filtered.length) + ' of ' + filtered.length;
      if (moreBtn) moreBtn.textContent = 'Show ' + Math.min(batch, left) + ' more';
    }
    moreBtn.addEventListener('click', function () { shown += batch; renderGrid(true); });
    if (sortSel) sortSel.addEventListener('change', function () { shown = batch; apply(true); });

    function updateCounts() {
      groups.forEach(function (g) {
        var base = products.filter(function (p) { return passes(p, g.key); });
        var counts = {};
        base.forEach(function (p) { BI.values(p, g.key).forEach(function (v) { counts[v] = (counts[v] || 0) + 1; }); });
        g.values.forEach(function (v) {
          var oid = 'bi-f-' + g.key + '-' + slug(v);
          var c = counts[v] || 0;
          var span = filtersEl.querySelector('[data-count-for="' + oid + '"]');
          var input = document.getElementById(oid);
          if (span) span.textContent = '(' + c + ')';
          if (input) {
            var label = input.closest('.bi-fopt');
            label.classList.toggle('is-empty', c === 0 && !input.checked);
            input.checked = !!(sel[g.key] && sel[g.key].indexOf(v) > -1);
          }
        });
        var s = filtersEl.querySelector('[data-sel-for="' + g.key + '"]');
        if (s) s.textContent = sel[g.key] ? ' (' + sel[g.key].length + ')' : '';
      });
    }

    function renderActive() {
      var chips = [];
      groups.forEach(function (g) {
        (sel[g.key] || []).forEach(function (v) {
          chips.push('<button type="button" class="bi-active__chip" data-rm-g="' + g.key + '" data-rm-v="' + BI.esc(v) + '">' +
            '<span class="visually-hidden">Remove filter: </span>' + BI.esc(v) + '<span aria-hidden="true"> ×</span></button>');
        });
      });
      activeEl.hidden = !chips.length;
      activeEl.innerHTML = chips.length ? chips.join('') + '<button type="button" class="bi-active__clear" data-bi-clear-all>Clear all</button>' : '';
    }
    root.addEventListener('click', function (e) {
      var rm = e.target.closest('[data-rm-g]');
      if (rm) {
        var k = rm.getAttribute('data-rm-g'), v = rm.getAttribute('data-rm-v');
        sel[k] = (sel[k] || []).filter(function (x) { return x !== v; });
        if (!sel[k].length) delete sel[k];
        shown = batch; apply(true);
        return;
      }
      if (e.target.closest('[data-bi-clear-all]')) { sel = {}; shown = batch; apply(true); }
    });

    /* ---------- URL (so filtered pages can be shared and Back works) ---------- */
    function readURL() {
      var q = new URLSearchParams(window.location.search);
      groups.forEach(function (g) {
        var v = q.get('f_' + g.key);
        if (v) sel[g.key] = v.split('|').filter(function (x) { return g.values.indexOf(x) > -1; });
        if (sel[g.key] && !sel[g.key].length) delete sel[g.key];
      });
      var s = q.get('sort');
      if (s && sortSel && sortSel.querySelector('option[value="' + s + '"]')) sortSel.value = s;
    }
    function writeURL() {
      var q = new URLSearchParams(window.location.search);
      Array.from(q.keys()).forEach(function (k) { if (k.indexOf('f_') === 0) q.delete(k); });
      q.delete('page');
      Object.keys(sel).forEach(function (k) { q.set('f_' + k, sel[k].join('|')); });
      if (sortSel && sortSel.value !== 'featured') q.set('sort', sortSel.value); else q.delete('sort');
      var qs = q.toString();
      history.replaceState(history.state, '', window.location.pathname + (qs ? '?' + qs : ''));
    }

    /* ---------- Mobile filter panel ---------- */
    function openPanel() {
      root.classList.add('bi-filters-open');
      scrim.hidden = false;
      openBtn.setAttribute('aria-expanded', 'true');
      document.documentElement.classList.add('bi-no-scroll');
      var c = panel.querySelector('.bi-coll__filters-close');
      if (c) c.focus();
    }
    function closePanel() {
      if (!root.classList.contains('bi-filters-open')) return;
      root.classList.remove('bi-filters-open');
      scrim.hidden = true;
      openBtn.setAttribute('aria-expanded', 'false');
      document.documentElement.classList.remove('bi-no-scroll');
      openBtn.focus();
    }
    openBtn.addEventListener('click', openPanel);
    root.querySelectorAll('[data-bi-filter-close]').forEach(function (b) { b.addEventListener('click', closePanel); });
    root.addEventListener('keydown', function (e) { if (e.key === 'Escape') closePanel(); });
  }

  function boot() {
    if (window.BICards) start();
    else document.addEventListener('bi:cards-ready', start, { once: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
